import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { ShoppingBag } from "lucide-react";

export const GoogleFeedCard = () => {
  const [rows, setRows] = useState(null);

  const load = () => {
    api.get("/feeds/google-exclusions").then(({ data }) => setRows(data.products)).catch(() => setRows([]));
  };
  useEffect(load, []);

  const toggle = async (id, excluded) => {
    try {
      await api.post("/feeds/google-exclude", { product_id: id, excluded });
      toast.success(excluded ? "Excluded from Google feed" : "Included in Google feed");
      load();
    } catch {
      toast.error("Could not update");
    }
  };

  if (!rows) return null;
  const excluded = rows.filter((r) => r.excluded);
  const included = rows.length - excluded.length;

  return (
    <div className="mt-10 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="google-feed-card">
      <div className="flex items-center gap-2">
        <ShoppingBag className="h-4 w-4 text-[#34C759]" />
        <h3 className="font-black text-xl tracking-tight">Google Shopping feed</h3>
      </div>
      <p className="mt-2 text-sm text-neutral-400">
        <span className="text-[#34C759] font-semibold">{included}</span> products in the feed ·{" "}
        <span className="text-[#FF9F0A] font-semibold">{excluded.length}</span> excluded.
        Listings that break Google policy (services, non-physical goods, placeholder prices under $1)
        are excluded automatically; flip the switch to exclude any listing manually.
      </p>
      <div className="mt-4 max-h-80 overflow-y-auto divide-y divide-[#27272A]">
        {rows.map((r) => (
          <div key={r.id} className="py-2.5 flex items-center justify-between gap-3" data-testid={`gfeed-row-${r.id}`}>
            <div className="min-w-0">
              <div className="text-sm text-white truncate">{r.title}</div>
              <div className="text-[11px] text-neutral-500">
                ${Number(r.price || 0).toFixed(2)} · {r.category}
                {r.excluded && (
                  <span className="text-[#FF9F0A]"> — {r.reason}</span>
                )}
              </div>
            </div>
            <Switch
              data-testid={`gfeed-switch-${r.id}`}
              checked={!r.excluded}
              disabled={r.excluded && !r.manual}
              onCheckedChange={(v) => toggle(r.id, !v)}
            />
          </div>
        ))}
      </div>
      <p className="mt-3 text-[11px] text-neutral-500">
        Auto-excluded listings (policy) can't be re-included until the listing itself is fixed —
        e.g. a real price or a physical-product category.
      </p>
    </div>
  );
};
